/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billingperiod1Inputs */

const en_billingperiod1 = /** @type {(inputs: Billingperiod1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing period`)
};

const de_billingperiod1 = /** @type {(inputs: Billingperiod1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnungszeitraum`)
};

/**
* | output |
* | --- |
* | "Billing period" |
*
* @param {Billingperiod1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const billingperiod1 = /** @type {((inputs?: Billingperiod1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billingperiod1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billingperiod1(inputs)
	return de_billingperiod1(inputs)
});
export { billingperiod1 as "billingPeriod" }